import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/CompanyDescriptionExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/FinancialInformationExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/FinancialNeedsExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_MARKET_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/MarketExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/ProductsExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_RISKS_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/RisksExecSummary/utils/form';
import { EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/TeamExecSummary/utils/form';

import { ol } from '../helpers';

const COMPANY_DESCRIPTION_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.HISTORY]: {
    name: 'Історія бізнесу',
    instruction:
      'Коротко представте заснування вашого бізнесу та ранні ключові етапи, включаючи ринкову потребу, яка спричинила його створення. Підкресліть початкові досягнення, такі як реєстрація компанії, отримання ліцензії або розробка прототипу.',
    exampleOne:
      'У 2020 році Компанія запустила свою першу модель гусеничного трактора, що революціонізувала землеробство на складних ґрунтах завдяки покращеному зчепленню та плавності руху.',
    exampleTwo:
      'У 2021 році мовна платформа запустила функцію перекладу на базі AI, революціонізувавши багатомовну комунікацію.',
  },
  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.RESOURCES_AND_ASSETS]: {
    name: 'Основні ресурси та активи',
    instruction:
      'Класифікуйте активи компанії: фізичні приміщення, обладнання, запаси та нематеріальні активи, такі як технології, інтелектуальна власність і бренд; оцініть їх.',
    exampleOne:
      'Основні ресурси та активи компанії включають сучасні виробничі приміщення, передові технології та обладнання, кваліфіковану робочу силу, інтелектуальну власність та стратегічні партнерства. Виробничі приміщення компанії оснащені передовими лініями виробництва та системами контролю якості, що дозволяє ефективно виготовляти високоякісну сільськогосподарську техніку.',
    exampleTwo:
      'Основні ресурси та активи компанії включають передові AI-технології, різноманітну мережу кваліфікованих перекладачів, надійні протоколи безпеки, відносини з клієнтами та права інтелектуальної власності.',
  },
  [EXECUTIVE_SUMMARY_COMPANY_DESCRIPTION_NAMES.COMPANY_OWNERS]: {
    name: 'Власники компанії',
    instruction:
      "Обов'язково вкажіть повне юридичне ім'я власників компанії. Перевірте правильність написання та форматування, щоб уникнути помилок.",
    exampleOne: '1.Джон Джонсон \n 2.Олівер Сміт',
    exampleTwo: '1.Джон Доу',
  },
};

const PRODUCTS_OR_SERVICES_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES.PRODUCT_VALUE]: {
    name: 'Цінність продукту/послуги та вирішувана проблема',
    instruction:
      'Чітко визначте основну ціннісну пропозицію вашого продукту та його здатність вирішувати проблему, розкривши переваги для клієнтів і практичний вплив.',
    exampleOne:
      'Завдяки мінімізації ущільнення ґрунту та максимізації тяги гусеничні трактори дозволяють фермерам працювати ефективніше, виконуючи завдання швидше та точніше.',
    exampleTwo:
      'Мовна сервісна платформа забезпечує безперешкодну комунікацію між різними мовами, дозволяючи клієнтам ефективно взаємодіяти з глобальною аудиторією та розширювати свою присутність.',
  },
};

const MARKET_AND_CUSTOMERS_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_MARKET_NAMES.DYNAMICS]: {
    name: 'Динаміка ринку',
    instruction:
      'Опишіть динаміку ринку: сили, що впливають на пропозицію, попит, конкуренцію, структуру галузі. Визначте CAGR цільового ринку. Обговоріть поточні тренди: зміни в поведінці споживачів, технологіях, найкращих практиках. Підкресліть вплив на бізнес і здатність адаптуватися.',
    exampleOne:
      'За останнє десятиліття ринок зростав із середньорічним темпом (CAGR) приблизно 5%, досягнувши загальної вартості понад $200 мільярдів у 2020 році. Це зростання зумовлене збільшенням механізації в країнах, що розвиваються, де впровадження сучасних методів ведення господарства прискорилося для задоволення зростаючого попиту на продукти харчування.',
    exampleTwo:
      'Ринок мовних послуг демонструє значне зростання, зумовлене глобалізацією, діджиталізацією та зростанням міжкордонної комунікації. Ключові тренди включають підвищений попит на AI-переклад, зростання на ринках, що розвиваються, впровадження хмарних мовних платформ та фокус на мовному різноманітті та локалізації.',
  },
  [EXECUTIVE_SUMMARY_MARKET_NAMES.COMPETITION_PLAN]: {
    name: 'Стратегія конкуренції',
    instruction:
      'Представте конкурентну стратегію: як ви плануєте відрізняти свої продукти від конкурентів. Підкресліть унікальні торговельні пропозиції: інновації, ціноутворення, клієнтський досвід. Опишіть позиціонування на ринку та ключові принципи.',
    exampleOne:
      'Компанія інвестує значні ресурси в дослідження та розробку для постійного вдосконалення продуктів, щоб залишатися на передовій технологічного прогресу та відповідати еволюціонуючим потребам клієнтів. Компанія надає пріоритет задоволенню клієнтів, забезпечуючи винятковий сервіс і підтримку на всіх етапах взаємодії.',
    exampleTwo:
      'Компанія планує диференціювати себе за рахунок фокусування на інноваціях, передових технологіях, персоналізованому сервісі та гнучкості. Постійно вдосконалюючи AI-технології, розширюючи мовну підтримку та забезпечуючи винятковий досвід клієнтів, компанія прагне випереджати конкурентів і зміцнювати позиції лідера у мовній індустрії.',
  },
};

const ORGANIZATION_AND_TEAM_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES.MEMBERS]: {
    name: 'Ключові члени команди',
    instruction: 'Перелічіть ключових членів команди',
    exampleOne: 'У Компанії ключовими учасниками проєкту є Джон Джонсон, Олівер Сміт, Ізабелла Браун та Генрі Міллер.',
    exampleTwo: 'У Компанії ключовими учасниками проєкту є Джон Джонсон, Мері Вілсон та Ліам Андерсон.',
  },
};

const FINANCIAL_INFORMATION_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.AVERAGE_ANNUAL_PROFIT]: {
    name: 'Середній річний прибуток за минулі роки',
    instruction:
      'Розрахуйте та надайте середній річний прибуток, підсумувавши чистий прибуток за останні три роки та поділивши на три. Це значення має бути точним і послідовно відображати фінансові результати за період.',
    exampleOne: '',
    exampleTwo: '',
  },
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.ASSETS_SIZE]: {
    name: 'Розмір ваших активів',
    instruction:
      'Щоб розрахувати розмір активів:' +
      ol([
        'Перелічте всі активи, включаючи готівку, інвестиції, нерухомість та обладнання.',
        'Визначте поточну ринкову вартість кожного активу.',
        'Підсумуйте значення, щоб отримати загальний розмір активів.',
      ]) +
      'Використовуйте формулу: Загальні активи = Готівка + Інвестиції + Нерухомість + Обладнання + Інші активи.',
    exampleOne: '',
    exampleTwo: '',
  },
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.PROJECTED_ANNUAL_PROFIT]: {
    name: 'Прогнозований річний прибуток',
    instruction:
      'Щоб розрахувати прогнозований річний прибуток на наступні три роки:' +
      ol([
        'Спрогнозуйте річний дохід на основі продажів і цінових тенденцій.',
        'Відніміть собівартість (COGS), щоб визначити валовий прибуток.',
        'Відніміть операційні витрати, податки та відсотки.',
        'Врахуйте очікуване зростання, ринкові умови та заплановані інвестиції або зміни витрат.',
      ]),
    exampleOne: '',
    exampleTwo: '',
  },
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.RETURN_ON_INVESTMENT]: {
    name: 'Рентабельність інвестицій (ROI)',
    instruction:
      'Щоб розрахувати рентабельність інвестицій (ROI):' +
      ol([
        'Визначте чистий прибуток від інвестиції.',
        'Поділіть чистий прибуток на початкову вартість інвестиції.',
        'Помножте на 100, щоб отримати значення у відсотках.',
      ]) +
      'Використовуйте формулу: ROI = (Чистий прибуток / Початкова вартість інвестиції) * 100.',
    exampleOne: '',
    exampleTwo: '',
  },
  [EXECUTIVE_SUMMARY_FINANCIAL_INFO_NAMES.INTERNAL_RATE_OF_RETURN]: {
    name: 'Внутрішня норма рентабельності (IRR)',
    instruction:
      'Щоб розрахувати внутрішню норму рентабельності (IRR):' +
      ol([
        'Зберіть дані про початкові інвестиції та грошові потоки.',
        'Визначте ставку, за якої чиста теперішня вартість (NPV) грошових потоків дорівнює нулю.',
        'Використовуйте фінансове програмне забезпечення для визначення IRR.',
      ]),
    exampleOne: '',
    exampleTwo: '',
  },
};

const FUNDING_DIRECTIONS_INSTRUCTIONS = {
  name: 'Напрями фінансування',
  instruction: 'Вкажіть розподіл бюджету для кожної мети: R&D, Маркетинг, Оборотний капітал, Будівництво, Обладнання.',
  exampleOne: '',
  exampleTwo: '',
};

const FINANCING_NEEDS_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.RESEARCH_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.MARKETING_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.WORKING_CAPITAL_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.CONSTRUCTION_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.EQUIPMENT_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },
  [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.OTHER_COST]: {
    currencyAmount: FUNDING_DIRECTIONS_INSTRUCTIONS,
    percentage: FUNDING_DIRECTIONS_INSTRUCTIONS,
  },
};

const RISKS_INSTRUCTIONS = {
  [EXECUTIVE_SUMMARY_RISKS_NAMES.MAIN_RISKS]: {
    name: 'Основні ризики проєкту',
    instruction:
      'Опишіть основні ризики проєкту: динаміка ринку, технологічні виклики, зміни регулювання, фінансова невизначеність. Оцініть вплив кожного ризику на успіх проєкту.',
    exampleOne: ol([
      'Неочікувані технічні складнощі під час процесу розробки.',
      'Ринкова волатильність і зміни вподобань клієнтів становлять ще один ризик, оскільки коливання економічних умов, регуляторної політики або конкурентної динаміки можуть вплинути на попит або змінити структуру ринку.',
    ]),
    exampleTwo:
      'Основні ризики для нашого проєкту включають технологічні збої, кіберзагрози, ринкову волатильність, зміни регуляторних вимог і конкуренцію. Додатково, залежність від зовнішніх постачальників або нестача кадрів може створити виклики.',
  },
  [EXECUTIVE_SUMMARY_RISKS_NAMES.MEASURES]: {
    name: 'Заходи з пом’якшення ризиків',
    instruction:
      'Опишіть заходи щодо зменшення ризиків: диверсифікація, страхування, резервні фонди, партнерства. Підкресліть постійний моніторинг ризиків і здатність команди адаптуватися. Підтвердьте ефективність стратегії управління ризиками.',
    exampleOne: ol([
      'Компанія застосовує передові стратегії управління ризиками, проводить ґрунтовні ринкові дослідження та підтримує відкриті канали комунікації зі стейкхолдерами, щоб вчасно виявляти потенційні проблеми та впроваджувати превентивні заходи.',
      'Компанія підтримує резервні плани та гнучкість у підході до проєкту, щоб адаптуватися до змінних умов та забезпечити успішні результати.',
    ]),
    exampleTwo:
      'Стратегії пом’якшення ризиків включають:' +
      ol(['Диверсифікацію джерел доходу', 'Стеження за тенденціями галузі', 'Підтримання надійних заходів безпеки']),
  },
};

export const EXECUTIVE_SUMMARY_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.COMPANY_DESCRIPTION]: COMPANY_DESCRIPTION_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.PRODUCTS_OR_SERVICES]: PRODUCTS_OR_SERVICES_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.MARKET_AND_CUSTOMERS]: MARKET_AND_CUSTOMERS_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.ORGANIZATION_AND_TEAM]: ORGANIZATION_AND_TEAM_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.FINANCIAL_INFORMATION]: FINANCIAL_INFORMATION_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.FINANCING_NEEDS]: FINANCING_NEEDS_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.RISKS]: RISKS_INSTRUCTIONS,
};
